import { render, staticRenderFns } from "./DemforCat.vue?vue&type=template&id=eac1ded4&"
import script from "./DemforCat.vue?vue&type=script&lang=js&"
export * from "./DemforCat.vue?vue&type=script&lang=js&"
import style0 from "./DemforCat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports